import script from "./IbgeRepository.vue?vue&type=script&lang=js"
export * from "./IbgeRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__